const CUSTOMER_TRANSFER_FEE_RATE = 0.33
// RE/MAX Revo(ADなし)
// 送客手数料率(税込) = 0.33
export function calcCustomerTransferFeeRate(): number {
  return CUSTOMER_TRANSFER_FEE_RATE
}
